import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, X } from "lucide-react";
import { api, errMsg } from "../lib/api";

export function MyTemplates({ current, onApply }) {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const load = () => api.get("/quote-templates").then((r) => setList(r.data));
  useEffect(() => {
    load();
  }, []);
  const save = async () => {
    try {
      await api.post("/quote-templates", { name, components: current() });
      toast.success(`Modèle « ${name} » enregistré`);
      setName("");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (t) => {
    try { await api.delete(`/quote-templates/${t.id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2" data-testid="my-templates">
      <span className="tl-label">Mes modèles</span>
      <div className="flex flex-wrap gap-2">
        {list.map((t) => (
          <span key={t.id} className="inline-flex items-center rounded-full border border-amber-500 bg-amber-50">
            <button className="px-3 py-1 text-sm font-semibold" onClick={() => onApply(t.components)} data-testid={`my-template-${t.id}`}>{t.name}</button>
            <button className="pr-2 text-slate-500 hover:text-red-600" onClick={() => remove(t)} aria-label="Supprimer le modèle" data-testid={`my-template-delete-${t.id}`}><X size={14} /></button>
          </span>
        ))}
        {!list.length && <span className="text-xs text-slate-500">Aucun modèle enregistré.</span>}
      </div>
      <div className="flex gap-2 max-w-md">
        <input className="tl-input !py-1" placeholder="Nom du modèle (ex. Liège 4 palettes)" value={name} onChange={(e) => setName(e.target.value)} data-testid="my-template-name" />
        <button className="tl-btn tl-btn-ghost tl-btn-sm" disabled={!name.trim()} onClick={save} data-testid="my-template-save"><Save size={14} /> Enregistrer la saisie</button>
      </div>
    </div>
  );
}
